/**
 * Проверяет, является ли период строкой в формате ISO 8601
 * @example "P1Y" => true
 */
export const validateIso8601Period = (period: unknown): period is string => {
  return typeof period === 'string' ? /P\d+[YMD]$/.test(period) : false;
};
